import React, { Component } from "react";
import BsySelect from "../BsySelect";
import BsySwitchBtn from "../BsySwitchBtn";
import BsySelectCheckBox from '../BsySelectCheckBox';

export default class AddUrlLinkPane extends Component{
    static defaultProps ={
        contactList: [],
        corpCoopList: [],
        is_tmp_owner: true,
        status: true,
        label_id: "",
        role_id: []
    }

    constructor(props) {
        super(props);
        this.state = {
            contactList: props.contactList,
            corpCoopList: props.corpCoopList,
            is_tmp_owner: props.is_tmp_owner,
            status: props.status,
            label_id: props.label_id,
            role_id: props.role_id
        }
    }

    getValue = () =>{
        const {is_tmp_owner, status, label_id, role_id} = this.state
        this.props.getValue && this.props.getValue({is_tmp_owner, status, label_id, role_id})
    }

    render(){
        const {contactList, corpCoopList, is_tmp_owner, status, label_id, role_id} = this.state;
        let contactItems = contactList.map(res=>{
            return {
                value: res.id,
                text: res.name
            }
        })
        let corpCoopItems = corpCoopList.map(res=>{
            return {
                value: res.id,
                text: res.name
            }
        })
        this.getValue();
        return (
            <div className="AddUrlLinkPane">
                <div className="pane-item coopName">
                    <div className="item-label">
                        <span className="label-name">{React.language('persona.corp.dept.label')}</span>
                    </div>
                    <div className="item-cont">
                        <BsySelect
                            allowBlank={false}
                            searchable={true}
                            height={36}
                            waterMark={React.language("label.setting")}
                            minWidth={200} 
                            onStopEdit={(e)=>{
                                this.setState({label_id: e})
                            }} 
                            value={label_id} 
                            items={corpCoopItems}
                        />
                    </div>
                </div>
                <div className="pane-item coopName">
                    <div className="item-label">
                        <span className="label-name">{React.language('contact.handover.role')}</span>
                    </div>
                    <div className="item-cont">
                        <BsySelectCheckBox
                            theme={this.props.theme}
                            allowBlank={false}
                            height={36}
                            value={role_id}
                            hasSelectAll={true}
                            hasSelectEmpty={false}
                            waterMark={React.language("docker.role.setting")}
                            items={contactItems}
                            onStopEdit={e1 => {
                                this.setState({role_id: e1})
                            }}
                            getContext={this.getContext}
                        />
                    </div>
                </div>
                <div className="pane-item coopName">
                    <div className="item-label">
                        <span className="label-name">{React.language('manager.contactAuth')}</span>
                        <span className="label-msg">{React.language('contact.escrow.setting.tip')}</span>
                    </div>
                    <div className="item-cont">
                        <BsySelect
                            allowBlank={false}
                            height={36}
                            searchable={true}
                            minWidth={200} value={is_tmp_owner} items={[
                                {
                                    text: React.language("contact.escrow"),
                                    value: true
                                },
                                {
                                    text: React.language('escrow.disabled'),
                                    value: false
                                }
                            ]}
                            onStopEdit={(e)=>{
                                this.setState({is_tmp_owner: e})
                            }}
                        />
                    </div>
                </div>
                <div className="pane-item">
                    <div className="item-label">
                        <span className="label-name">{React.language('link.state')}</span>
                    </div>
                    <div className="item-cont">
                        <BsySwitchBtn switchChange={e => { this.setState({ status: e }) }} power={status} />
                    </div>
                </div>
            </div>
        )
    }
}